'use strict';

window.jQuery = require('jquery');
window.$ = require('jquery');
const processInclude = require('base/util');
require('lazysizes');
require('lazysizes/plugins/parent-fit/ls.parent-fit');
require('lazysizes/plugins/attrchange/ls.attrchange');

// GTM hub (incl. PayPal express XHR patch) before cartExpressPayments user interaction.
require('./gtm');

$(document).ready(function () {
	processInclude(require('./components/header'));
	processInclude(require('./components/menu'));
	processInclude(require('base/components/cookie'));
	processInclude(require('base/components/consentTracking'));
	//processInclude(require('./components/cookieConsentAccessibility'));
	processInclude(require('./components/footer'));
	processInclude(require('./components/miniCart'));
	processInclude(require('base/components/collapsibleItem'));
	processInclude(require('./components/desktopSearch'));
	processInclude(require('./components/mobileSearch'));
	processInclude(require('./components/search'));
	processInclude(require('./components/clientSideValidation'));
	processInclude(require('./components/countrySelector'));
	processInclude(require('./components/mobileCountrySelector'));
	processInclude(require('./components/geoRedirectModal'));
	processInclude(require('./components/cartErrorMessaging'));
	processInclude(require('base/components/toolTip'));
	processInclude(require('./components/cartShippingTooltip'));

	/* Components custom */
	processInclude(require('./components/dropdown'));
	processInclude(require('./components/accountQuickLinks'));
	processInclude(require('./components/accordion'));
	processInclude(require('./components/faqSearchBar'));
	processInclude(require('./components/navTabs'));
	processInclude(require('./components/skipLink'));
	processInclude(require('./components/drawer'));
	processInclude(require('./components/productQuantityStepper'));
	processInclude(require('./components/multiplePurchase'));
	processInclude(require('./components/notifyMe'));
	processInclude(require('./components/priorBestPrice'));
	processInclude(require('./components/niceSelect'));
	processInclude(require('./components/datePicker'));
	processInclude(require('./gigyaSync'));
	processInclude(require('./components/loyalty'));
	processInclude(require('./components/zuoraAccountSync'));
});

/* Thrid party integration */
require('base/thirdParty/bootstrap');
require('./thirdParty/bootstrap');
require('base/components/spinner');
require('./spinner');
